import styled, { keyframes } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`
export const Image = styled.div`
  background-position: center center;
  background-size: cover;
  width: 144px;
  height: 116px;
  flex-shrink: 0;
  margin-right: 16px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`

export const AvailabilityFeedback = styled.div`
  font-size: 16px;
  font-weight: var(--font-medium);
  margin-bottom: 10px;
  padding: 0 50px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 0 20px;
  }
`

export const FromPrice = styled.div`
  color: var(--grey-100);
  font-size: 13px;
  font-weight: var(--font-medium);

  & > span {
    text-decoration: line-through;
  }
`

export const PriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: row;
  gap: 4px;
  font-weight: var(--font-bold);
  position: relative;
`

export const Price = styled.span<{ strikePrice?: boolean }>`
  color: var(--${({ strikePrice }) => (strikePrice ? 'sale' : 'black')});
  font-weight: var(--font-bold);
  font-size: 14px;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`

export const Loading = styled.div`
  display: inline-block;
  min-height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  color: #dddbdd;
  width: 100%;
  height: 100%;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
    animation: ${shimmer} 2s infinite;
    content: '';
  }
`

export const LoadingBlock = styled.div`
  margin-bottom: 20px;
  height: 50px;
  width: 100%;
  border: 1px solid #f8f8f8;
  border-radius: 5px;
  overflow: hidden;
`

export const BookingSteps = styled.div`
  box-sizing: border-box;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`
